var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { "ok-variant": "info", "ok-disabled": _vm.state.isFetching },
      on: { ok: _vm.savePayment },
      model: {
        value: _vm.state.showModal,
        callback: function($$v) {
          _vm.$set(_vm.state, "showModal", $$v)
        },
        expression: "state.showModal"
      }
    },
    [
      _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("message.payment_method.add_payment")) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("payment-form", {
            ref: "paymentForm",
            attrs: { paymentData: _vm.paymentData }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          attrs: { slot: "modal-cancel" },
          on: {
            click: function($event) {
              _vm.state.showModal = false
            }
          },
          slot: "modal-cancel"
        },
        [_vm._v(_vm._s(_vm.$t("message.button.close")))]
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "modal-ok" }, slot: "modal-ok" }, [
        _vm._v(_vm._s(_vm.$t(_vm.isAdding)))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-063bf47c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-063bf47c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/payment/UserPaymentForm.vue
// module id = 1790
// module chunks = 0